import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth.slice";
import { authApi } from "./apis/auth.api";
import toastSlice from "./slices/toast.slice";
import { treatmentsApi } from "./apis/treatments.api";
import { coordinatorApi } from "./apis/coordinator.api";
import { treatmentCoursesApi } from "./apis/treatment-courses.api";
import dataTableStateSlice from "./slices/data-table-state.slice";

const store = configureStore({
    reducer: {
        toast: toastSlice.reducer,
        auth: authSlice.reducer,
        dataTableState: dataTableStateSlice.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [treatmentsApi.reducerPath]: treatmentsApi.reducer,
        [coordinatorApi.reducerPath]: coordinatorApi.reducer,
        [treatmentCoursesApi.reducerPath]: treatmentCoursesApi.reducer,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([
            authApi.middleware,
            treatmentsApi.middleware,
            coordinatorApi.middleware,
            treatmentCoursesApi.middleware,
        ]),
});

export default store;



export type StoreRootState = ReturnType<typeof store.getState>;